/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import SectionHeader from './SectionHeader';
import SortableList from '/client/src/components/sortableList/container';
import arrayMove from 'array-move';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import _ from 'lodash';

type PropsType = {
  onHandleChangeSC: () => void,
  editablePart?: any
};

const SoundCloud = (props: PropsType): React.Element => {
  const { onHandleChangeSC, editablePart } = props;

  const initUrls = () => {
    const urls =  _.get(editablePart, 'audio', []);

    return urls.map((el, i) => ({
     ...el,
     id: 0 - i,
     temp_id: -1001 - i,
     can_delete: true
   }));
   };

  const [urls, setUrls] = React.useState(initUrls());
  const urlRef = React.useRef();
  const context = React.useContext(DefaultContainerContext);

  const onSortEnd = ({ oldIndex, newIndex }: any) => {
    const newItems = arrayMove(urls, oldIndex, newIndex);

    setUrls(newItems);

    onHandleChangeSC({
      audio: _.map(newItems, (_url: {}, urli: number): {} => {
        return {
          url: _url.url,
          placement_index: urli + 1
        };
      })
    });
  };

  const handleAddUrl = () => {
    const url = urlRef.current.value;

    if (!url.startsWith('https://soundcloud.com/')) {
       context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: 'SoundCloud URL is invalid!'
      });
      return false;
    }

    const newItems = [
      ...urls,
      {
        id: 0 - _.size(urls),
        name: '',
        temp_id: -1001 - _.size(urls) - 1,
        url,
        can_delete: true
      }
    ];

    setUrls(newItems);
    urlRef.current.value = '';

    onHandleChangeSC({
      audio: _.map(newItems, (_url: {}, urli: number): {} => {
        return {
          url: _url.url,
          placement_index: urli + 1
        };
      })
    });
  };

  const handleRemoveUrl = (tempId: string | number, id: string | number) => {
    const newItems = _.map(urls, (t: {}): {} => {
      if (t.tempId) {
        if (t.tempId !== tempId) {
          return t;
        }
      } else if (t.id !== id) {
        return t;
      }
    });
    const newFiltered = _.compact(newItems);

    setUrls(newFiltered);
    onHandleChangeSC({
      audio: _.map(newFiltered, (_url: {}, urli: number): {} => {
        return {
          url: _url.url,
          placement_index: urli + 1
        };
      })
    });
  };

  return (
    <>
      <SectionHeader
        {...props}
        onHandleChange={onHandleChangeSC}
        title={_.get(editablePart, 'link_label') || 'SoundCloud'}
      />

      <div className="row">
        <div className="col-xs-12">
          <div className="form-group SimpleInput">
            <label className="col-xs-12 control-label">Soundcloud URL</label>
            <div className="col-xs-12">
              <div className="input-group">
                <input
                  ref={urlRef}
                  type="text"
                  className="form-control"
                  id="input-add-sound-url"
                />
                <span className="input-group-btn">
                  <button
                    className="btn btn-default"
                    id='button-add-sound-player'
                    type="button"
                    onClick={handleAddUrl}
                  >add player</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {!!_.size(urls) &&
        <div className="row">
          <div className="col-xs-12">
            <br/>
            <SortableList
              items={urls}
              // eslint-disable-next-line
              onSortEnd={onSortEnd}
              useDragHandle
              useWindowAsScrollContainer
              disableAutoscroll
              // eslint-disable-next-line
              handleRemoveTicket={handleRemoveUrl}
              item={Audio2}
              // eslint-disable-next-line
              handleControlTicketData={setUrls}
            />
          </div>
        </div>
      }
    </>
  );
};

type Audio2PropsType = {
  id?: string | number,
  value: {
    temp_id?: string | number,
    url: string
  }
};
const Audio2 = (props: Audio2PropsType): React.Element<'div'> => {
  return (
    <div className="splash-iframe" key={`p.audio-${props.value.temp_id || props.id}`}>
      <iframe
        frameBorder="0"
        style={{
          width: '100%',
          height: '166px'
        }}
        src={`${process.env.SOUNDCLOUD_PAYER_URL}?url=${props.value.url}`}
      />
    </div>
  );
};

export default SoundCloud;
